import React from 'react'
import styled from 'styled-components'

/**
 * リンクテキスト
 */
const LinkText: React.FC<LinkTextProps> = (props) => {
  return <StyledLinkText {...props} />
}

export type LinkTextProps = {
  children: React.ReactNode
  color?: string
}

export const StyledLinkText = styled.span<{
  color?: string
}>`
  display: block;
  color: ${(props): string =>
    props.color ? props.color : 'var(--color-text)'};
  font-weight: 600;
  font-size: 17px;
  letter-spacing: -0.41px;
  white-space: pre-wrap;
`

export default LinkText
